<template>
  <div class="about">
    <h1 class="display-2 py-4 mx-4 text-xs-left" style="font-weight: 500;">Group Support Meetings</h1>

    <p class="title mx-4">
    The Group Support Meetings are an opportunity to learn more about ME/CFS and ways to manage this illness. The meetings are a place to connect with others with ME/CFS and their whānau and share experiences with those who understand.
    <br/><br/>Our Group Meetings are open to anyone, non-members are encouraged to attend to come and learn more about what we offer.
    <br/><br/>Each meeting focuses on a particular topic, often presented by a guest speaker followed by afternoon tea (gluten and dairy free options available) and time to socialize.
    <br/><br/>The Monthly Group Support Meeting is held on the last Wednesday of each month at Abberley Park Hall, St Albans, Christchurch from 1.30pm to 3.30pm.
    <br/><br/>Please get in contact for more info
    </p>

    <br/>
    <div style="display: flex; flex-direction: row; align-items: center; margin-left: 25px;">
        <v-img src="./fb-button.png" aspect-ratio="1.0" :contain=true min-width="30" max-width="40"></v-img>
        <p class="title mx-4">Checkout the <a class="title" style="color: #248;" href="https://www.facebook.com/pg/mecfscanterburyinc/events/">Facebook event</a></p>
    </div>
    <div style="display: flex; flex-direction: row; align-items: center; margin-left: 25px;">
        <v-img src="./mu-button.png" aspect-ratio="2.0" :contain=true min-width="60" max-width="70"></v-img>
        <p class="title mx-4">Or our <a class="title" style="color: #248;" href="https://www.meetup.com/Canterbury-Myalgic-Encephalomyelitis-and-CFS-Support-Group/">Meetup Group</a></p>
    </div>

    <br/>
    <div id="mapdiv" style="width: 100%; height: 500px"></div>
  </div>
</template>

<script>

export default {
	name: "Meeting",
  mounted() {
    let checkAPILoaded = () => {
      setTimeout( () => {
        if (mapsAPILoaded) {
          let div = this.$el.querySelector("#mapdiv");

          // 55 Abberley Cres, St Albans, Christchurch 8014
          var park = {lat: -43.5137, lng: 172.6306};
          var map = new google.maps.Map(div, { zoom: 14, center: park });
          var marker = new google.maps.Marker({ position: park, map: map });
        } else {
          checkAPILoaded();
        }
      }, 100);
    }
    checkAPILoaded();
  }
}

</script>